//

import React from "react";
import CommonSwitch from "../../../components/Common/commonSwitch";
import { Link, useNavigate } from "react-router-dom";

const FinalStep = ({ step, setStep }) => {
  //
  const navigate = useNavigate();

  return (
    <>
      <div className="mx-auto flex flex-col gap-4 relative">
        <button
          onClick={() => setStep(11)}
          className="absolute sm:top-[5px] top-[-20px] transform  left-0"
        >
          {backIcn}
        </button>
        <div className="text-center">
          <h4 className="m-0 sm:text-[30px] text-[22px] font-semibold tracking-[1px]">
            YOUR AI CHARACTER{" "}
            <span className=" bg-gradient-to-r from-[#8B9AD4] to-[#C588C8] bg-clip-text text-transparent">
              MADISON PARKER
            </span>
          </h4>
        </div>
        <div className="">
          <div className="mx-auto mt-5 rounded-[12px]">
            <div className="grid gap-4 grid-cols-12">
              <div className="sm:col-span-6 col-span-12 sm:order-1 order-2">
                <div className="flex flex-col gap-3 max-w-[370px]">
                  <div className="mb-5">
                    <ul className="list-none pl-0 mb-0 flex flex-col gap-4">
                      <li className="flex items-center gap-2">
                        <p className="m-0">Public</p>
                        <CommonSwitch
                          defaultChecked={false}
                          onToggle={(val) => console.log("Switch value:", val)}
                        />
                      </li>
                      <li className="flex items-center gap-2">
                        <p className="m-0">Add to Marketplace</p>
                        <CommonSwitch
                          defaultChecked={false}
                          onToggle={(val) => console.log("Switch value:", val)}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="py-3">
                    <h6 className="m-0 font-medium pb-3 text-[18px]">
                      Meet Madison Parker
                    </h6>
                    <p className="m-0 text-[#A3A3A3]">
                      Madison is a dedicated 24-year-old nurse, whose
                      compassionate touch and nurturing spirit bring comfort to
                      her patients. Her bright blonde hair frames a warm face,
                      and her caring blue eyes radiate kindness, creating an
                      aura of trust and safety for those in her care. With a
                      calming smile and a gentle laugh, Madison has a remarkable
                      ability to lighten the heaviest of days, making her a
                      cherished presence in the hospital. Her blend of
                      professionalism and empathy showcases her intelligence and
                      heart, making her not only an exceptional caregiver but
                      also a beloved friend.
                    </p>
                  </div>
                  {/* <div className="py-3">
                    <div className="flex items-center justify-center gap-2 w-full text-[12px] sm:flex-nowrap flex-wrap">
                      <button
                        onClick={() => navigate("/chat")}
                        className="flex items-center justify-center text-white gap-2 border border-[#FFA4D8]  rounded-[12px] h-[40px] bg-[#E443A6] px-3 whitespace-nowrap sm:w-auto w-full"
                      >
                        <span className="flex-shrink-0">{chatIcn}</span> Chat
                      </button>
                      <button
                        // onClick={() => openModal("call-pop")}
                        className="flex items-center justify-center text-white gap-2 border border-[#FFA4D8]  rounded-[12px] h-[40px] bg-[#E443A6] px-3 whitespace-nowrap sm:w-auto w-full"
                      >
                        <span className="flex-shrink-0">{callIcn}</span> Call
                      </button>
                      <button
                        onClick={() =>
                          navigate({
                            pathname: "/interactive-video",
                          })
                        }
                        className="flex items-center justify-center text-white gap-2 border border-[#FFA4D8]  rounded-[12px] h-[40px] bg-[#E443A6] px-3 whitespace-nowrap sm:w-auto w-full"
                      >
                        <span className="flex-shrink-0">{generatvidIcn}</span>{" "}
                        Interactive Video
                      </button>
                    </div>
                  </div> */}
                  {/* <Link
                    href={"/generate-image"}
                    className="flex items-center justify-center w-full border border-[#E443A6] bg-[#000] text-[#fff]  rounded-[12px] gap-2 h-[40px] bg-tranparent px-3 transition duration-[400ms] hover:bg-[#E443A6]"
                  >
                    {aiIcn} Image & Video Generator
                  </Link> */}
                </div>
              </div>
              <div className="sm:col-span-6 col-span-12 sm:order-2 order-1">
                <img
                  src={"/assets/media/standingmodel1.png"}
                  alt=""
                  className="max-w-full h-auto w-full max-h-[calc(100vh-110px)] object-contain "
                  height={10000}
                  width={10000}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalStep;

const chatIcn = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 13.3333C10.3485 13.3333 13.3333 10.3485 13.3333 6.66667C13.3333 2.98477 10.3485 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 7.73313 0.250413 8.74106 0.69564 9.635C0.81396 9.87253 0.85334 10.1441 0.784746 10.4004L0.387673 11.8845C0.2153 12.5287 0.804673 13.118 1.4489 12.9457L2.93293 12.5486C3.18929 12.48 3.46081 12.5194 3.69835 12.6377C4.59225 13.0829 5.6002 13.3333 6.66667 13.3333Z"
      fill="white"
    />
  </svg>
);

const callIcn = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7483 12.1297C13.3161 13.4429 11.6231 14.0978 10.4135 13.9886C8.76147 13.8393 6.96388 12.9631 5.59934 11.998C3.59361 10.5793 1.71481 8.38488 0.620009 6.05621C-0.153724 4.41074 -0.327322 2.38765 0.823478 0.887786C1.24908 0.333386 1.70921 0.0372935 2.40081 0.00276018C3.36028 -0.0439065 3.49468 0.504988 3.82414 1.35992C4.06961 1.99925 4.39721 2.65142 4.58014 3.31409C4.92268 4.55076 3.72521 4.60244 3.57401 5.61324C3.47974 6.25071 4.25254 7.10558 4.60161 7.56012C5.28574 8.45052 6.10801 9.21849 7.03574 9.80276C7.56681 10.1378 8.42454 10.7416 9.03307 10.4084C9.97014 9.89509 9.88147 8.31503 11.1919 8.84983C11.8704 9.1261 12.5275 9.52479 13.1752 9.87385C14.1767 10.4124 14.13 10.9705 13.7483 12.1297C14.0339 11.2636 13.4627 12.9958 13.7483 12.1297Z"
      fill="white"
    />
  </svg>
);

const generatvidIcn = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8384 5.04977L11.6641 5.45068C11.6369 5.51597 11.591 5.57173 11.5321 5.61096C11.4732 5.65018 11.4041 5.67112 11.3333 5.67112C11.2626 5.67112 11.1934 5.65018 11.1346 5.61096C11.0757 5.57173 11.0298 5.51597 11.0025 5.45068L10.8283 5.04977C10.5219 4.34053 9.96085 3.77188 9.25579 3.45602L8.71817 3.21589C8.65294 3.18589 8.59769 3.13781 8.55896 3.07736C8.52022 3.01691 8.49964 2.94662 8.49964 2.87483C8.49964 2.80303 8.52022 2.73275 8.55896 2.6723C8.59769 2.61185 8.65294 2.56377 8.71817 2.53377L9.22604 2.30781C9.94883 1.98295 10.5195 1.39327 10.8205 0.660224L10.9997 0.227432C11.026 0.160391 11.0719 0.102835 11.1314 0.0622668C11.191 0.0216985 11.2613 0 11.3333 0C11.4054 0 11.4757 0.0216985 11.5352 0.0622668C11.5947 0.102835 11.6406 0.160391 11.667 0.227432L11.8462 0.659516C12.1468 1.39269 12.7173 1.98263 13.4399 2.30781L13.9485 2.53447C14.0135 2.56456 14.0686 2.61263 14.1072 2.67301C14.1458 2.73338 14.1663 2.80353 14.1663 2.87518C14.1663 2.94683 14.1458 3.01699 14.1072 3.07736C14.0686 3.13773 14.0135 3.1858 13.9485 3.21589L13.4102 3.45531C12.7052 3.77148 12.1444 4.34039 11.8384 5.04977ZM11.3333 7.0841C11.8158 7.08459 12.2949 7.00291 12.75 6.84256V13.4641C12.7498 13.6505 12.6756 13.8293 12.5438 13.9612C12.4119 14.0931 12.2331 14.1672 12.0466 14.1674H0.703375C0.516828 14.1674 0.337922 14.0933 0.206014 13.9614C0.0741054 13.8295 0 13.6506 0 13.4641V2.12081C0 1.73264 0.315208 1.41743 0.703375 1.41743H7.32487C7.09819 2.05859 7.02868 2.74477 7.12217 3.41836C7.21565 4.09195 7.46942 4.73327 7.86214 5.28846C8.25487 5.84364 8.77508 6.29648 9.3791 6.60894C9.98311 6.92139 10.6533 7.08434 11.3333 7.0841ZM5.39892 5.25306C5.35629 5.22461 5.30674 5.20827 5.25555 5.20576C5.20437 5.20324 5.15346 5.21466 5.10825 5.23879C5.06304 5.26292 5.02522 5.29887 4.99882 5.34279C4.97242 5.38671 4.95843 5.43698 4.95833 5.48822V10.0966C4.95843 10.1479 4.97242 10.1982 4.99882 10.2421C5.02522 10.286 5.06304 10.3219 5.10825 10.3461C5.15346 10.3702 5.20437 10.3816 5.25555 10.3791C5.30674 10.3766 5.35629 10.3602 5.39892 10.3318L8.85487 8.02831C8.89374 8.00244 8.92561 7.96738 8.94765 7.92623C8.9697 7.88508 8.98123 7.83912 8.98123 7.79243C8.98123 7.74575 8.9697 7.69979 8.94765 7.65864C8.92561 7.61749 8.89374 7.58242 8.85487 7.55656L5.39892 5.25306Z"
      fill="white"
    />
  </svg>
);

const aiIcn = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_84_541)">
      <path
        d="M13.9638 10.2509C14.3016 10.2509 14.6196 10.2499 14.9366 10.2509C15.0956 10.2518 15.0975 10.2546 15.0975 10.4144C15.0984 12.0683 15.106 13.7222 15.0975 15.376C15.0918 16.5694 14.2789 17.6125 13.1405 17.9019C12.9257 17.9564 12.6995 17.9912 12.4781 17.9922C9.20569 17.9987 5.93331 18.0034 2.66092 17.9969C1.29349 17.994 0.199539 17.0233 0.0140595 15.6749C-0.00202803 15.5593 -0.000135387 15.4409 -0.000135387 15.3243C-0.000135387 12.1021 -0.00202803 8.87986 -0.000135387 5.65763C-0.000135387 4.36084 0.898871 3.28394 2.17357 3.04337C2.28145 3.0227 2.39122 3.00954 2.501 3.0086C4.15138 3.00579 5.80082 3.00579 7.45121 3.00391C7.5307 3.00391 7.55247 3.0321 7.55247 3.10633C7.54963 3.40234 7.54773 3.69929 7.55436 3.99529C7.55625 4.1043 7.51934 4.13437 7.41146 4.13343C5.84057 4.13061 4.26873 4.14189 2.69783 4.12591C2.05906 4.11933 1.29065 4.5516 1.14965 5.42458C1.13072 5.54298 1.13072 5.66608 1.13072 5.78636C1.12883 8.92309 1.12883 12.0589 1.12693 15.1956C1.12693 15.5414 1.17425 15.8731 1.37203 16.1663C1.68053 16.623 2.11395 16.8673 2.66944 16.8692C4.0558 16.8739 5.44311 16.8711 6.82947 16.8711C8.70319 16.8711 10.5769 16.8786 12.4506 16.8702C13.3089 16.8664 13.9638 16.1776 13.9638 15.3892C13.9638 13.7503 13.9638 12.1124 13.9647 10.4736C13.9647 10.4041 13.9647 10.3345 13.9647 10.25L13.9638 10.2509Z"
        fill="white"
      />
      <path
        d="M13.4718 9.07176C13.3071 9.07176 13.2617 8.99188 13.2323 8.89134C13.1462 8.59627 13.0677 8.29838 12.9702 8.00614C12.8084 7.51655 12.6106 7.04294 12.3277 6.60692C11.952 6.02712 11.4305 5.62117 10.8117 5.3308C10.2495 5.06675 9.65809 4.88257 9.05717 4.72939C8.94929 4.70214 8.85844 4.66361 8.85277 4.54051C8.84709 4.40614 8.94929 4.37325 9.05717 4.34036C9.52087 4.19564 9.98741 4.05939 10.4445 3.89494C11.6056 3.47771 12.3911 2.67896 12.8037 1.52595C12.9626 1.08241 13.0932 0.629472 13.2333 0.179354C13.2787 0.0327604 13.344 -0.0292599 13.4623 0.0130267C13.521 0.0337001 13.5825 0.102298 13.6024 0.162439C13.6913 0.432134 13.7604 0.708407 13.8475 0.979041C14.0027 1.46205 14.19 1.93096 14.4569 2.36792C14.8912 3.0774 15.5206 3.55289 16.2861 3.84701C16.7782 4.03589 17.2892 4.17873 17.7917 4.34318C17.8457 4.36103 17.9091 4.37888 17.946 4.41741C18.0539 4.53206 17.9905 4.67019 17.8211 4.72188C17.3895 4.85156 16.9542 4.9709 16.5303 5.12219C15.8839 5.35242 15.2963 5.68131 14.8316 6.20003C14.4578 6.61726 14.2004 7.10214 14.015 7.62368C13.8749 8.01553 13.7613 8.41773 13.6364 8.81428C13.6203 8.86596 13.6128 8.92517 13.5825 8.96745C13.5484 9.01632 13.4935 9.05109 13.4708 9.07082L13.4718 9.07176Z"
        fill="white"
      />
      <path
        d="M9.09876 14.1415C9.0382 14.1462 8.99656 14.1509 8.95492 14.1509C8.62465 14.1509 8.29533 14.1471 7.96507 14.1518C7.86854 14.1537 7.8269 14.119 7.79851 14.0306C7.63953 13.5251 7.47298 13.0223 7.314 12.5177C7.28561 12.4275 7.24018 12.3955 7.14555 12.3965C6.47366 12.4002 5.80177 12.3984 5.13083 12.3993C4.95671 12.3993 4.96239 12.4012 4.91034 12.5694C4.75703 13.0721 4.60089 13.5749 4.44096 14.0757C4.4315 14.1067 4.38513 14.1471 4.35485 14.1481C4.00565 14.1528 3.65551 14.1509 3.30632 14.15C3.29213 14.15 3.27793 14.1415 3.25049 14.1321C3.28929 14.0109 3.32714 13.8944 3.36405 13.7769C3.97348 11.8327 4.58386 9.88936 5.19329 7.94511C5.23682 7.80791 5.28224 7.67072 5.32293 7.53258C5.34186 7.4668 5.37593 7.44049 5.4488 7.44143C5.90398 7.44425 6.3601 7.43955 6.81528 7.44425C6.84935 7.44425 6.90045 7.49405 6.9137 7.53164C7.06701 7.98176 7.21463 8.43282 7.36321 8.88387C7.92154 10.5744 8.47892 12.264 9.03725 13.9545C9.05523 14.009 9.07416 14.0645 9.09971 14.1415H9.09876ZM7.01591 11.406C6.70267 10.4024 6.39417 9.41293 6.08851 8.43282C5.79799 9.4195 5.50558 10.409 5.21222 11.406H7.01591Z"
        fill="white"
      />
      <path
        d="M11.1608 7.4461C11.1608 7.51376 11.1608 7.57202 11.1608 7.62935C11.1608 9.70421 11.1608 11.7781 11.1608 13.853C11.1608 13.8605 11.1608 13.869 11.1608 13.8765C11.1634 14.0588 11.0741 14.1496 10.893 14.149C10.6299 14.149 10.3669 14.1452 10.1038 14.1499C10.0101 14.1518 9.97319 14.1302 9.97414 14.0278C9.97792 11.9181 9.97698 9.80852 9.97792 7.69888C9.97792 7.43483 9.97887 7.43859 10.2495 7.44235C10.5164 7.4461 10.7832 7.44235 11.0501 7.44141C11.0842 7.44141 11.1182 7.44422 11.1608 7.4461Z"
        fill="white"
      />
      <path
        d="M11.6749 1.1504C11.6247 1.17577 11.5774 1.21054 11.5244 1.2237C11.143 1.31955 10.9074 1.55917 10.7995 1.93223C10.7825 1.99143 10.7427 2.04406 10.7143 2.0995L10.6784 2.09762C10.6576 2.05439 10.6282 2.01305 10.6159 1.96794C10.5128 1.59394 10.2904 1.33646 9.90523 1.2284C9.84372 1.21054 9.79167 1.15792 9.73584 1.12221C9.79167 1.09214 9.84372 1.04985 9.90334 1.03294C10.2866 0.924871 10.5147 0.673031 10.6188 0.29809C10.6311 0.254864 10.6708 0.219155 10.6983 0.179688C10.7276 0.217276 10.7607 0.253924 10.7853 0.294331C10.8033 0.323462 10.8137 0.358231 10.8241 0.39206C10.9263 0.726594 11.1553 0.92957 11.4875 1.0273C11.5518 1.04609 11.6124 1.07898 11.6758 1.10435C11.6758 1.12033 11.6758 1.1363 11.6758 1.15228L11.6749 1.1504Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_84_541">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const imgIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.61885 1.5H7.66832C8.01292 1.5 8.33918 1.5 8.64672 1.50151C9.00612 1.50329 9.29605 1.79609 9.29432 2.15551C9.29252 2.51493 8.99972 2.80485 8.64032 2.80309C8.33625 2.80159 8.01305 2.80159 7.66732 2.80159C6.19168 2.80159 5.15042 2.80297 4.36207 2.90896C3.59244 3.01243 3.162 3.20475 2.85037 3.51639C2.53874 3.82802 2.34642 4.25846 2.24294 5.02809C2.13696 5.81644 2.13557 6.85767 2.13557 8.33333C2.13557 9.809 2.13696 10.8502 2.24294 11.6386C2.34642 12.4082 2.53874 12.8387 2.85037 13.1503C3.162 13.4619 3.59244 13.6542 4.36207 13.7577C5.15042 13.8637 6.19168 13.8651 7.66732 13.8651C9.14298 13.8651 10.1842 13.8637 10.9726 13.7577C11.7422 13.6542 12.1727 13.4619 12.4843 13.1503C12.7959 12.8387 12.9882 12.4082 13.0917 11.6386C13.1976 10.8502 13.199 9.809 13.199 8.33333C13.199 7.9876 13.199 7.6644 13.1976 7.36033C13.1958 7.00093 13.4857 6.70813 13.8451 6.70633C14.2046 6.7046 14.4974 6.99453 14.4991 7.35393C14.5006 7.66153 14.5006 7.9878 14.5006 8.33247V8.3818C14.5006 9.79786 14.5006 10.9269 14.3816 11.812C14.2588 12.726 13.9984 13.4769 13.4046 14.0707C12.8109 14.6644 12.06 14.9248 11.146 15.0477C10.2608 15.1667 9.13185 15.1667 7.71578 15.1667H7.61885C6.20276 15.1667 5.07381 15.1667 4.18864 15.0477C3.27468 14.9248 2.52378 14.6644 1.93001 14.0707C1.33623 13.4769 1.07584 12.726 0.952965 11.812C0.833958 10.9269 0.833971 9.79786 0.833985 8.3818V8.28487C0.833971 6.8688 0.833958 5.73982 0.952965 4.85465C1.07584 3.94069 1.33623 3.18981 1.93001 2.59603C2.52379 2.00225 3.27468 1.74186 4.18864 1.61898C5.0738 1.49997 6.20275 1.49999 7.61885 1.5Z"
      fill="white"
    />
    <path
      d="M6.33268 5.66536C6.33268 6.40174 5.73573 6.9987 4.99935 6.9987C4.26297 6.9987 3.66602 6.40174 3.66602 5.66536C3.66602 4.92898 4.26297 4.33203 4.99935 4.33203C5.73573 4.33203 6.33268 4.92898 6.33268 5.66536Z"
      fill="white"
    />
    <path
      d="M12.3333 0.833984C12.5425 0.833984 12.7297 0.964251 12.8023 1.16046L12.9742 1.62515C13.2155 2.27738 13.2925 2.45459 13.4193 2.58136C13.5461 2.70812 13.7233 2.7851 14.3755 3.02644L14.8402 3.19839C15.0364 3.271 15.1667 3.4581 15.1667 3.66732C15.1667 3.87654 15.0364 4.06364 14.8402 4.13624L14.3755 4.30819C13.7233 4.54954 13.5461 4.62651 13.4193 4.75328C13.2925 4.88004 13.2155 5.05725 12.9742 5.70948L12.8023 6.17417C12.7297 6.37038 12.5425 6.50065 12.3333 6.50065C12.1241 6.50065 11.937 6.37038 11.8644 6.17417L11.6925 5.70948C11.4511 5.05725 11.3741 4.88004 11.2474 4.75328C11.1206 4.62651 10.9434 4.54954 10.2911 4.30819L9.82647 4.13624C9.63027 4.06364 9.5 3.87654 9.5 3.66732C9.5 3.4581 9.63027 3.271 9.82647 3.19839L10.2911 3.02644C10.9434 2.7851 11.1206 2.70812 11.2474 2.58136C11.3741 2.45459 11.4511 2.27738 11.6925 1.62515L11.8644 1.16046C11.937 0.964251 12.1241 0.833984 12.3333 0.833984Z"
      fill="white"
    />
    <path
      d="M3 14.3339C5.91497 10.8506 9.18273 6.25663 13.9983 9.36224C13.9983 10.8888 13.9983 11.6521 13.753 12.2556C13.4143 13.0889 12.7533 13.75 11.9201 14.0886C11.3165 14.3339 10.5532 14.3339 9.0266 14.3339H3Z"
      fill="white"
    />
  </svg>
);

const leftArrow = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9141 15.8327L7.08073 9.99935L12.9141 4.16602"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const backIcn = (
  <svg
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.390361 9.428L7.93303 16.9707L9.81836 15.0853L3.21836 8.48533L9.81836 1.88533L7.93303 0L0.390361 7.54267C0.1404 7.7927 -2.09808e-05 8.13178 -2.09808e-05 8.48533C-2.09808e-05 8.83889 0.1404 9.17797 0.390361 9.428Z"
      fill="#E7E6F8"
    />
  </svg>
);
